import React from "react";
import { useTranslation } from "react-i18next";
import type { ConnectorDeviceDescription } from "../../api/connectorsApi";
import DefinitionListItem from "../../ui/layout/DefinitionListItem";
import { classNames } from "../../ui/styles/classNames";
import { FORM_DIVIDED_LIST_CLASS } from "../../ui/styles/formStyles";
import { platformText } from "./devicePlatform";

interface ConnectorDeviceDetailsProps {
  device: ConnectorDeviceDescription;
  /** Leave out the PC name where a heading already shows it. */
  showLabel?: boolean;
  /** Rows shown before the device's own (such as the code), and after it (such as times). */
  leadingRows?: React.ReactNode;
  trailingRows?: React.ReactNode;
}

/** What a connector reports about its PC: name, system, version and key fingerprint. */
export default function ConnectorDeviceDetails({
  device,
  showLabel = true,
  leadingRows,
  trailingRows,
}: ConnectorDeviceDetailsProps) {
  const { t } = useTranslation();

  return (
    <dl className={classNames(FORM_DIVIDED_LIST_CLASS, "app-detail-list-inline")}>
      {leadingRows}
      {showLabel ? (
        <DefinitionListItem term={t("connectors.device.label")}>
          <span className="font-semibold">{device.label}</span>
        </DefinitionListItem>
      ) : null}
      <DefinitionListItem term={t("connectors.device.platform")}>{platformText(device)}</DefinitionListItem>
      <DefinitionListItem term={t("connectors.device.version")}>{device.connectorVersion}</DefinitionListItem>
      <DefinitionListItem term={t("connectors.device.keyFingerprint")} valueClassName="font-mono text-xs">
        {device.keyFingerprint}
      </DefinitionListItem>
      {trailingRows}
    </dl>
  );
}
